<app-header></app-header>

<div class="vincent_title_block vincent_corners">
    <div class="vincent_inner_text">
        <h1>{{"checkout" | translate}}</h1>
    </div>
</div>

<div class="vincent_container vincent_typography">
    <div class="row gutters">
        <div class="col col-12 vincent_content">
            <div class="vincent_checkout">
                <div class="row justify-center">
                    <h3 class="main-label"> {{"addetional_details" | translate}} </h3>
                    <form class="form-details" #f="ngForm" (ngSubmit)="confirm(f)">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="vincent_billing_fields">


                                <label class="flex-center_1">{{"payment_method" | translate}}</label>

                                <div class="select">

                                    <select class="vincent_checkout_select" [ngModel]="selectedmethod"
                                     (ngModelChange)="onChange($event)" [ngModelOptions]="{standalone: true}">
                                        <option  disabled value="selected" [selected]="selected"></option>
                                        <option [ngValue]="i" *ngFor="let i of methods">{{i}}</option>
                                    </select>
                                   
                                </div>

                                <label class="flex-center_1">{{"brunch_name" | translate}}</label>

                                <div class="select">
                                <select class="vincent_checkout_select" [ngModel]="brunchSelectedMethod"
                                    (ngModelChange)="brunchOnChange($event)" [ngModelOptions]="{standalone: true}">
                                       <option  disabled value="selected" [selected]="selected"></option>
                                       <option [ngValue]="i" *ngFor="let i of brunchMethods">{{i}}</option>
                                   </select>
                                </div>

                            </div>
                            
                            <label class="flex-center_1">{{"details_about_the_order" | translate}}</label>
                            
                            <textarea class="center" placeholder='{{"your_message" | translate}}' ngModel name='message'></textarea>
                        
                        </div>

                        <input type="text" [ngModel]="confirmed" ng-value="confirmed" #status name='status' style="display: none;">

                        <input type="submit" value='{{"confirm" | translate}}' class="confirm-btn mg-bottom" [disabled]="f.invalid || brunch == false || payment == false" id="confirm-btn">
                        
                        <p id="confirm-p" style="display: none;"> ..تم تأكيد طلبك,قيد التحضير</p>
                        
                        <div class="alert alert-primary cus" role="alert" style="display: none;" id="done">
                            تم  تأكيد طلبك,قيد التحضير
                        </div>
                    
                    </form>

                </div>

            </div>
            <!-- <h3 style="text-align: right;">طلبك</h3> -->
            <!-- <table class="vincent_order">
                    <thead>
                        <tr>
                            <th>الصنف</th>
                            <th>الكل</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Margherita <strong>× 1</strong></td>
                            <td> ريال 2.60</td>
                        </tr>
                        <tr>
                            <td>Pepperoni <strong>× 1</strong></td>
                            <td> ريال 2.90</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>الكل</th>
                            <td> ريال 5.50</td>
                        </tr>
                        <tr>
                            <th>الأجمالي</th>
                            <td> ريال 5.50</td>
                        </tr>
                    </tfoot>
                </table> -->
        </div>
    </div>
</div>

<app-footer></app-footer>